import React, { useEffect, useRef, useState } from "react";

import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";

import { UserAuth } from "../Context";
import useFetch from "../hooks/useFetch";
import TestProductCard2 from "../Experiments/TestMasonry/TestProductCard2";
import { useInView } from "react-intersection-observer";
import { collection, doc, getDoc, getDocs, limit, orderBy, query, where } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import useLogsStore from "../StatesStore/Logs";
import useUserDataStore from "../StatesStore/UserData";
import axios from "axios";
import Skeleton from "../Products/Skeleton";
import TestProductCard4 from "../Experiments/TestMasonry/TestProductCard4";




export default function DiscoverMasonry() {
  const [masonry, setmasonry] = useState();

  const { user } = UserAuth();
  const [expandedCards, setExpandedCards] = useState({}); // Track expanded state of cards

  // //api endpoint for logged-out user
  // let url = process.env.REACT_APP_API + `/api/logoutFeed`;
  // const { data, isLoading } = useFetch(url);
  const [isLoading, setIsLoading] = useState(false);
  // Invoke Masonry Function
  function initMasonry() {
    var elem = document.querySelector(".grid");
    var grid = new Masonry(elem, {
      itemSelector: ".grid-item",
      columnWidth: ".grid-sizer",
      transitionDuration: "0.3s",
      stagger: 20,
    });
    //Update masonry cards as each image loads
    imagesLoaded(elem).on("progress", function () {
      grid.layout();
    });
    setmasonry(grid);
  }

  //Handles Expanded Effect on Click
  const handleClick = (productId) => {
    setExpandedCards((prev) => ({
      ...prev,
      [productId]: !prev[productId], // Toggle expand/collapse for this card
    }));

    setTimeout(() => {
      masonry.layout();
    }, 300);
  };


  const { ref: loadMoreRef, inView: loadMoreView } = useInView({
    threshold: 0.1,
  });
  const { ref: loginRef, inView: modalView } = useInView({
    threshold: 1,
    // delay :5000,
    rootMargin: "-170px",
  });
 
  const logs = useLogsStore((state) => state.logs);
  const userData = useUserDataStore((state) => state.userData);

  const [productIds, setProductIds] = useState(null);
  const [products, setProducts] = useState([]);
 
  const [hasNextPage, setHasNextPage] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  //Update Masonry upon setting NewsFeed
  useEffect(() => {
    if (isLoading) return;
    initMasonry();
  }, [products]);



  // Fetch product IDs from logs or user preferences
  const fetchProductIdsFromLogs = async () => {
    if (logs && logs.length > 0) return logs;
    const ids = [];
    try {
      const logsRef = collection(db, "users", user?.uid, "logs");
      const logsQuery = query(
        logsRef,
        where("productId", "!=", null),
        orderBy("timestamp", "desc"),
        limit(10)
      );
      const logsSnapshot = await getDocs(logsQuery);

      logsSnapshot.forEach((doc) => {
        const logData = doc.data();
        if (logData.productId) ids.push(logData.productId);
      });

      if (ids.length === 0 && userData?.favCategories) {
        return userData.favCategories;
      } else if (ids.length === 0) {
        const userRef = doc(db, "users", user?.uid);
        const userSnapshot = await getDoc(userRef);
        return userSnapshot.data()?.favCategories || [];
      }
      return ids;
    } catch (error) {
      console.error("Error fetching productIds from logs:", error);
      return [];
    }
  };

  // Fetch products based on the current page number
  const fetchProducts = async () => {
    if (!productIds || isLoading) return;
    setIsLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_RECOMMENDER}/api/recommend/${user?.uid}`,
        {
          input: productIds,
          page_number: pageNumber,
          items_per_page: 25,
        }
      );

      const newProducts = response.data;

      setProducts((prev) => [...prev, ...newProducts]);

      if (newProducts.length < 25) {
        setHasNextPage(false); // No more pages
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Load product IDs on component mount
  useEffect(() => {
    const initializeProductIds = async () => {
      if (!user) return;

      const ids = await fetchProductIdsFromLogs();
      setProductIds(ids);
    };

    initializeProductIds();
  }, [user]);

  // Fetch products whenever page number changes
  useEffect(() => {
    if (productIds) {
      fetchProducts();
    }
  }, [productIds, pageNumber]);

  // Trigger next page fetch when the "load more" ref is in view
  useEffect(() => {
    if (loadMoreView && hasNextPage && !isLoading) {
      setPageNumber((prev) => prev + 1);
    }
  }, [loadMoreView]);
  //Spinner
  // if (isLoading) {
  //   return (
  //     <div
  //       className="d-flex justify-content-center align-items-center"
  //       style={{ height: "100vh" }}
  //     >
  //       <div className="spinner-border" role="status">
  //         <span className="visually-hidden">Loading...</span>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="px-3 w-100">
      <div className="grid">
        <div className="grid-sizer"></div>
        {isLoading &&
            Array.from({ length: 25 }).map((_, index) => (
             
                <Skeleton />
             
            ))}
        {products.map((item) => {
        
            return (
              <div
                key={item.id}
                className={`grid-item ${expandedCards[item.id] ? "grid-item--width3" : ""}`}
              >
                <TestProductCard4
                  product={item}
                  isExpanded={expandedCards[item.id]}
                  handleClick={() => handleClick(item.id)}
                />
              </div>
            );
         
        })}
           {/* <div ref={loadMoreRef}></div> */}
      </div>
    </div>
  );
}
